import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_LCM_PETITION_SIGNER_RECEIPT_WELCOME_CONFIG = defineFcm('lcm_petition_signer_receipt_welcome_config')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				constraints: {
					type: 'array',
					shape: { type: 'string' },
				},
			},
		}),
	)
	.withDefault(undefined)
	.toConfig();
